export default {
  name: 'connecting',
  props: {
    timeToRedirect: {
      type: Number,
      required: true
    },
    redirectUrl: {
      type: String,
      required: true
    },
  },
  mounted() {
    const queryParams = new URLSearchParams(window.location.search)
    const planType = queryParams.get('type')
    // this.$store.dispatch('overlay/activateOverlay', `${planType.toLowerCase()}-wifi`)
    const timeout = setTimeout(() => {
      window.location.href = this.redirectUrl
      clearTimeout(timeout)
    }, this.timeToRedirect)
  },
  render() {
    return this.$scopedSlots.default()
  }
}